import { getFallbackParamountItem } from '../../data/fallback-data/get-fallback-paramount-item';
import { useUpNextItems } from './use-up-next-items';
import { useEquipmentType } from '../selectors/use-equipment-type';
import { IUpNextItem } from '@ifit/gateway-wolf-dashboard-service';

export function useParamountItem(): { data: IUpNextItem; isLoading: boolean; error: Error | null; isSuccess: boolean } {
  const equipmentType = useEquipmentType();
  const queryResult = useUpNextItems(false);

  const paramountItem = queryResult.data && queryResult.data.length > 0 ? queryResult.data[0] : null;
  const singleItemQueryResult = { ...queryResult, data: paramountItem };

  if (singleItemQueryResult.error || !singleItemQueryResult.data) {
    singleItemQueryResult.data = getFallbackParamountItem(equipmentType);
    singleItemQueryResult.isSuccess = true;
  }

  return singleItemQueryResult;
}
